import React from 'react';
import styled from '../../theme/styled';

interface MainTextProps {
    light: boolean;
}

interface TextContainerProps {
    text_align: string;
}

interface MainProps extends TextContainerProps, MainTextProps {
    className: string;
}

const HeadingContainer = styled.div<TextContainerProps>`
    text-align: ${props => props.text_align};
    @media only screen and (max-width: 1200px) {
        text-align: center;
    }
`;

const HeadingText = styled.h1<MainTextProps>`
    margin: 0 0 1em 0;
    color: ${props => props.light ? "white" : props.theme.colors.dark[1]};
    display: inline-block;
    .underscore {
        margin-top: 20px;
        height: 10px;
        background-color: ${props => props.light ? "white" : "#007CFF"};
        border-radius: 9999px;
}`;

export class Heading extends React.Component<MainProps> {
    public static defaultProps = {
        light: false,
        text_align: "left",
        className: "",
    };


    render() {
        return (<HeadingContainer className={this.props.className} text_align={this.props.text_align}><HeadingText light={this.props.light}>{this.props.children}</HeadingText></HeadingContainer>);
    }
}

//Text component below

const TextContainer = styled.div<TextContainerProps>`
    text-align: ${props => props.text_align};
`;


const ParagraphText = styled.p<MainTextProps>`
    color: ${props => props.light ? "white" : props.theme.colors.dark[1]};
`;

export class Text extends React.Component<MainProps> {
    public static defaultProps = {
        light: false,
        text_align: "left",
        className: "",
    };

    render() {
        return (<TextContainer className={this.props.className} text_align={this.props.text_align}><ParagraphText light={this.props.light}>{this.props.children}</ParagraphText></TextContainer>);
    }
}


// WEBPACK FOOTER //
// ./src/components/base/Text.tsx